const actions = {
  SET_ERROR: "SET_ERROR",
  SET_SUCCESS: "SET_SUCCESS",
  SET_ALERT: "SET_ALERT",
  SET_BRAND: "SET_BRAND",
} as const;

export default actions;
